<!-- src/components/OnlineFooter.vue -->
<script setup>
import { computed } from 'vue'
import { useWebsiteConfigStore } from '../../stores/website/configStore'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  isMobileView: {
    type: Boolean,
    required: true
  }
})

const websiteStore = useWebsiteConfigStore()

const branding = computed(() => websiteStore.config.branding)
const meta = computed(() => websiteStore.config.meta)
const social = computed(() => websiteStore.config.social)
const contact = computed(() => websiteStore.config.contact)

const currentYear = new Date().getFullYear()
</script>

<template>
  <footer class="online-footer" :class="{ 'mobile': isMobileView }">
    <div class="footer-container">
      <!-- Sección del logo y descripción -->
      <div class="footer-brand">
        <img :src="branding?.logo_navbar" :alt="meta?.website_name" class="footer-logo">
        <p v-if="!isMobileView" class="website-description">{{ meta?.description }}</p>
      </div>

      <!-- Enlaces y Contacto -->
      <div class="footer-links">
        <div class="contact-info" v-if="!isMobileView">
          <h3>{{ t('footer.contactUs') }}</h3>
          <p v-if="contact?.email">
            <font-awesome-icon :icon="['fas', 'envelope']" />
            {{ contact.email }}
          </p>
          <p v-if="contact?.phone">
            <font-awesome-icon :icon="['fas', 'phone']" />
            {{ contact.phone }}
          </p>
        </div>

        <!-- Redes Sociales con Efectos -->
        <div class="social-links">
          <h3 v-if="!isMobileView">{{ t('footer.followUs') }}</h3>
          <ul class="social-icons">
            <li v-if="social?.facebook">
              <a :href="social.facebook" target="_blank" class="social-icon facebook">
                <font-awesome-icon :icon="['fab', 'facebook']" />
              </a>
            </li>
            <li v-if="social?.instagram">
              <a :href="social.instagram" target="_blank" class="social-icon instagram">
                <font-awesome-icon :icon="['fab', 'instagram']" />
              </a>
            </li>
            <li v-if="social?.tiktok">
              <a :href="social.tiktok" target="_blank" class="social-icon tiktok">
                <font-awesome-icon :icon="['fab', 'tiktok']" />
              </a>
            </li>
            <li v-if="social?.telegram">
              <a :href="social.telegram" target="_blank" class="social-icon telegram">
                <font-awesome-icon :icon="['fab', 'telegram']" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Contact Info Mobile -->
    <div v-if="isMobileView" class="mobile-contact">
      <p v-if="contact?.email" class="contact-item">
        <font-awesome-icon :icon="['fas', 'envelope']" />
        {{ contact.email }}
      </p>
    </div>

    <!-- Copyright -->
    <div class="footer-bottom">
      <p>© {{ currentYear }} {{ meta?.website_name }}.{{ t('footer.allRightsReserved') }}.</p>
    </div>
  </footer>
</template>

<style scoped>
@import '../../assets/styles/online/OnlineMain.css';
</style>
